<template>
  <div class="dashboard-container">
        <div class="main-box">
             <span class="text">欢迎进入后台管理系统</span>
        </div>

  </div>
</template>

<script>
    import img_welcome from '@/assets/images/welcome.png'
    // import { getColumnTree } from '@/api/jingshi';
    import { mapGetters } from 'vuex';
    export default {
      name: 'dashboard',
      data(){
          return{
               img_welcome,
               list:[],
               downloadLoading:false
          }
      },
      computed:{
        ...mapGetters(['userInfo'])
        },
      methods:{

      },
      created:function(){
        // getColumnTree();
      }
    }
</script>

<style media="screen">

.main-box{
    width: 900px;
    height: 60px;
    position: relative;
    text-align: center;
    line-height: 60px;
    font-size: 24px;
    margin: 0px auto;
    margin-top: 240px;
    color: #595959;

    /* position: absolute; */

}

.text{
    font-size: 36px;
    letter-spacing: 1.2px;
}

.enText {
    width: 900px;
    /* margin-left: -60px; */
    margin-top: -24px;
    font-size: 16px;
    /* font-weight: bold; */

    color: #AEAEAE;
}

.main-box img{
    position: absolute;
    right: -9px;
    top: -45px;
}

</style>



// WEBPACK FOOTER //
// index.vue?5ccdf032